/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three'
import React, { useMemo, useState } from 'react'
import { useThree } from '@react-three/fiber';

import { delModel, extrudeSettings, roofPattern, textureAnisotropy } from '../../../../../../../../utils/Functions';
import { const_var, params } from '../../../../../../../../redux/reducers/reducer';
import { CSG } from '../../../../../../../../assets/libs/csg-lib';
import { MaterialInnerWall, MaterialOuterWallNew, MaterialWainScotWallNew } from '../../../../../../CustomMaterial';
import { getSimilarTexture, textureAppliedFor } from '../../../../../../../../redux/reducers/utils';

const WallModel = () => {
    const { gl } = useThree ();

    const canvasElement = document.getElementsByClassName("buildingcanvas")
    const isPattern = (canvasElement != undefined && canvasElement[0]?.clientWidth > 1050 && !params.p_v_w) ? true : false

    const [isStorageSideWall, setIsStorageSideWall] = useState(false);

    const cbFrontBackWallOffset = 0.16;
    const wallThickness = 0.005;
    const railWidth = 0.2;

     

    const texture = useMemo(() => {
        if(const_var.metalTexture){
            let texture = const_var.metalTexture.clone();
            textureAnisotropy(gl, texture,1.3, 1.3, (params.p_v_w != true) ? 0 :  Math.PI/-2);    
            return texture
        }else{
            return null
        }
    }, [params.p_v_w,params.wallTexture,const_var.wallTextureObj[params.wallTexture]])

    let offset;
    
    const legDistance = useMemo(() => {
        return (const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined) ? const_var.DistanceArr[params.p_b_t][params.p_r_s] : 5
    }, [const_var.DistanceArr, params.p_b_t, params.p_r_s,params.fourth_center_cost,const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined && const_var.DistanceArr[params.p_b_t][params.p_r_s]])

    if(params.leanB_p_d % legDistance === 0) offset = 0.15;
    else offset = 0;

    const wallPosOffset = useMemo(() => {
        if(params.backLeanStoragePosition > 0 && params.backLeanStoragePosition !== params.leanB_p_d - parseInt(params.add_storage_back) - 0.2) return railWidth;
        else return 0;
    }, [params.backLeanStoragePosition, params.leanB_p_d, params.add_storage_back])

    // Storage Right Wall - CSG
    const storageRightWallModelObj = useMemo(() => {
        let mainWall;
        let innerWall;
        let wainscotWall;

        //************************* */ main wall geometry
        let verticalHorizontalPosStorageS = {"x": params.leanB_p_d / -2,"y" : (params.p_w_c_n ? 2.935 : 0), "z" : params.p_d / -2 - 0.22}
        let verticalHorizontalRotStorageS = {"x":0,"y" : Math.PI / 2,"z" : Math.PI / 2}
        let patternLengthStorageS = params.leanB_p_h + (params.p_r_s === 1 ? const_var.roofRegularDst * 2 : 0) + ((params.b_l_t_r_pB/12) * params.leanB_p_w) + (params.p_w_c_n ? -2.935 : 0)
        let patternDepthStorageS = parseInt(params.add_storage_back) + offset + wallPosOffset

        const storageSideWallModel = new THREE.Shape();
        storageSideWallModel.moveTo(-params.leanB_p_d / 2, 0);
        storageSideWallModel.lineTo(-params.leanB_p_d / 2, params.leanB_p_h + (params.p_r_s === 1 ? const_var.roofRegularDst * 2 : 0) + (params.leanB_p_w - 0.05) * params.b_l_t_r_pB / 12);
        storageSideWallModel.lineTo(-params.leanB_p_d / 2 + parseInt(params.add_storage_back) + offset + wallPosOffset, params.leanB_p_h + (params.p_r_s === 1 ? const_var.roofRegularDst * 2 : 0) + (params.leanB_p_w - 0.05) * params.b_l_t_r_pB / 12);
        storageSideWallModel.lineTo(-params.leanB_p_d / 2 + parseInt(params.add_storage_back) + offset + wallPosOffset, 0);
        storageSideWallModel.closePath();

        const meshSideStorageWallModelPattern = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(patternLengthStorageS, isPattern), extrudeSettings(patternDepthStorageS)));
        const meshBackStorageInnerWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(storageSideWallModel, extrudeSettings(wallThickness)), new THREE.MeshStandardMaterial({ color: 'brown' }))
        const meshBackStorageInDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('backLeanStorageRight', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))
    
        let meshStorageWallModel_Temp = meshSideStorageWallModelPattern.clone();
        meshStorageWallModel_Temp.position.set(verticalHorizontalPosStorageS.x,verticalHorizontalPosStorageS.y,verticalHorizontalPosStorageS.z);
        meshStorageWallModel_Temp.rotation.set(verticalHorizontalRotStorageS.x,verticalHorizontalRotStorageS.y,verticalHorizontalRotStorageS.z);
        meshStorageWallModel_Temp.updateMatrixWorld();
    
        let meshBackStorageInnerWallModel_Temp = meshBackStorageInnerWallModel.clone();
        meshBackStorageInnerWallModel_Temp.position.set(0, 0, -(params.p_d / 2 + cbFrontBackWallOffset + 0.07));
        meshBackStorageInnerWallModel_Temp.updateMatrixWorld()

        let meshBackStorageInDelModel_Temp = meshBackStorageInDelModel.clone();
        meshBackStorageInDelModel_Temp.rotateY(Math.PI)
        meshBackStorageInDelModel_Temp.position.set(-params.leanB_p_pos - params.backLeanStoragePosition, 0, -(params.p_d / 2 - 0.5));
        meshBackStorageInDelModel_Temp.updateMatrixWorld()
    
        const meshBackStorageInnerWallModel_CSG = CSG.fromMesh(meshBackStorageInnerWallModel_Temp);
        const meshBackStorageInDelModel_CSG = CSG.fromMesh(meshBackStorageInDelModel_Temp);
        const meshStorageWallModel_CSG = CSG.fromMesh(meshStorageWallModel_Temp);
    
        const backStorageInnerWallModel_CSG =  meshBackStorageInnerWallModel_CSG.subtract(meshBackStorageInDelModel_CSG);
        const storageSideWallModel_CSG = meshStorageWallModel_CSG.subtract(meshBackStorageInDelModel_CSG);
    
        const CSGBackStorageOuterWallModel = CSG.toMesh(storageSideWallModel_CSG, new THREE.Matrix4(), new THREE.MeshStandardMaterial({ color: 'blue' }))
        const CSGBackStorageInnerWallModel = CSG.toMesh(backStorageInnerWallModel_CSG, new THREE.Matrix4(), new THREE.MeshStandardMaterial({ color: 'blue' }))

        mainWall = CSGBackStorageOuterWallModel.geometry;
        innerWall = CSGBackStorageInnerWallModel.geometry;

        //************************* */ wainscot wall geometry
        let wainscotVerticalHorizontalPosStorageS = {"x": params.leanB_p_d / -2,"y" : 0, "z" : params.p_d / -2 - 0.22}
        let wainscotVerticalHorizontalRotStorageS = {"x":0,"y" : Math.PI / 2,"z" : Math.PI / 2}
        let lengthPatternStorageS = 3
        let depthPatternStorageS = patternDepthStorageS

        const meshStorageRightWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(lengthPatternStorageS, isPattern), extrudeSettings(depthPatternStorageS)));
        let meshStorageRightWainscotModel_Temp = meshStorageRightWainscotModel.clone();
        meshStorageRightWainscotModel_Temp.position.set(wainscotVerticalHorizontalPosStorageS.x,wainscotVerticalHorizontalPosStorageS.y,wainscotVerticalHorizontalPosStorageS.z);
        meshStorageRightWainscotModel_Temp.rotation.set(wainscotVerticalHorizontalRotStorageS.x,wainscotVerticalHorizontalRotStorageS.y,wainscotVerticalHorizontalRotStorageS.z);
        meshStorageRightWainscotModel_Temp.updateMatrixWorld();

        const meshStorageRightWainscotModel_CSG = CSG.fromMesh(meshStorageRightWainscotModel_Temp);

        const storageRightWainscotModel_CSG = meshStorageRightWainscotModel_CSG.subtract(meshBackStorageInDelModel_CSG);
        const CSGStorageRightWainscotModel = CSG.toMesh(
            storageRightWainscotModel_CSG,
            new THREE.Matrix4()
        )

        wainscotWall = CSGStorageRightWainscotModel.geometry;

        return {mainWall, innerWall, wainscotWall}    

    }, [params.wallTexture,params.leanB_p_h, params.leanB_p_d, params.b_l_t_r_pB, wallPosOffset, params.backLeanStoragePosition, params.leanB_p_w, params.add_storage_back, params.p_w_c_n, params.lean_p_w, params.p_d, params.p_v_w, const_var.newDoorsArray, params.add_storage_check_back, params.leanB_p_pos, isPattern]);
    
    useMemo(() => {
        let array = const_var.newDoorsArray.filter((item) => item.userData.wallName === 'c_b_b_w' && item.height > params.leanB_p_h);
        for(let i=0; i<array.length; i++) {
            let item = array[i];
            const doorPositionX = item.positionX;
            const doorWidth = item.width
            const LeftStoragePos = params.leanB_p_pos - params.leanB_p_d / 2 + parseInt(params.add_storage_back)
            const RightStoragePos = params.leanB_p_pos - params.leanB_p_d / 2
            if((RightStoragePos >= (doorPositionX - doorWidth / 2)) && (LeftStoragePos <= (doorPositionX + doorWidth / 2))){
                setIsStorageSideWall(true)
                return;
            } 
            setIsStorageSideWall(false)
        }
        if(array.length == 0) setIsStorageSideWall(false)

    }, [const_var.newDoorsArray, params.leanB_p_pos, params.leanB_p_d, params.add_storage_back, params.leanB_p_h])

    return (
        <>
            {storageRightWallModelObj?.mainWall && !isStorageSideWall &&
                <mesh name="B_L_B_S_W" geometry={storageRightWallModelObj?.mainWall} renderOrder={1}>
                    <MaterialOuterWallNew isPattern={isPattern} visibleSection={"backLean"} />
                </mesh>
            }

            <group name='in-side-wall'>
                {storageRightWallModelObj?.innerWall &&
                    <mesh name="storage-left" geometry={storageRightWallModelObj?.innerWall} position={[0, 0, -wallThickness - 0.01]}>
                        <MaterialInnerWall texture={texture} visibleSection={"backLean"} />
                    </mesh>
                }
            </group>
            {params.p_w_c_n == true && storageRightWallModelObj?.wainscotWall &&
                <mesh name="B_L_B_S_W_wainscot" geometry={storageRightWallModelObj?.wainscotWall} position={[0,0,0.005]} renderOrder={1}>
                    <MaterialWainScotWallNew isPattern={isPattern} visibleSection={"backLean"} />
                </mesh>
            }
        </>
    )
}

export default WallModel